import React from 'react';
import { Register } from './Register';
import View from '../../../../shared/components/View/View';
import useQuery from '../../../../shared/hooks/useQuery';
import { UserPanelRegistrationInformation } from './types';
import Loader from '../../../../shared/components/Loader';
import { Home } from './Home';
import { parseRegistration } from './util';
import { useLocalization } from '../../../../shared/components/l10n/l10n';
import './style.css';

export default function UserCommunity() {
    const loadingTexts = useLocalization(textIds);
    const userRegistrationQuery = useQuery<UserPanelRegistrationInformation>(`/user-panel`, {});

    if (loadingTexts || userRegistrationQuery.loading) {
        return <Loader />;
    }

    return (
        <View className="view__user_panel">
            <View.Content>
                {!!userRegistrationQuery.data.userGuid ? (
                    <Home data={parseRegistration(userRegistrationQuery.data)} refresh={userRegistrationQuery.refetch} />
                ) : (
                    <Register refresh={userRegistrationQuery.refetch} />
                )}
            </View.Content>
        </View>
    );
}

export const textIds = [
    'USER_PANEL_AREASOFINTEREST',
    'USER_PANEL_AREASOFINTEREST_INVENTORY_FEEDBACK_GROUP',
    'USER_PANEL_HERO_INFORMATION',
    'USER_PANEL_DEACTIVATE_ARE_YOU_SURE',
    'USER_PANEL_DEACTIVATE_BUTTON',
    'USER_PANEL_EDIT_BUTTON',
    'USER_PANEL_INFORMATION',
    'USER_PANEL_INFORMATION_LANGUAGES',
    'USER_PANEL_INFORMATION_PARTICIPATION',
    'USER_PANEL_SURVEY_INFORMATION',
    'USER_PANEL_SURVEY_BUTTON',
    'USER_PANEL_JOIN_TITLE',
    'USER_PANEL_JOIN_INFORMATION_1',
    'USER_PANEL_JOIN_INFORMATION_2',
    'USER_PANEL_JOIN_BUTTON',
    'USER_PANEL_PARTICIPATE_TITLE',
    'USER_PANEL_PARTICIPATE_INFORMATION_1',
    'USER_PANEL_PARTICIPATE_INFORMATION_2',
    'USER_PANEL_CHARITY_TITLE',
    'USER_PANEL_CHARITY_INFORMATION_1',
    'USER_PANEL_STEP_DONE_TITLE',
    'USER_PANEL_STEP_DONE_INFORMATION_1',
    'USER_PANEL_STEP_DONE_BUTTON',
    'USER_PANEL_STEP_PERSONAL_INFORMATION',
    'USER_PANEL_STEP_PERSONAL_TITLE',
    'USER_PANEL_STEP_PERSONAL_INFORMATION',
    'USER_PANEL_STEP_PERSONAL_DPA',
    'USER_PANEL_STEP_LANGUAGES_TITLE',
    'USER_PANEL_STEP_LANGUAGES_INFORMATION_1',
    'USER_PANEL_STEP_LANGUAGES_INFORMATION_2',
    'USER_PANEL_STEP_PARTICIPATION_TITLE',
    'USER_PANEL_STEP_PARTICIPATION_INFORMATION_1',
    'USER_PANEL_STEP_PARTICIPATION_INFORMATION_2',
    'USER_PANEL_SAVE_SUCCESS',
    'USER_PANEL_STEP_PARTICIPATION_METHOD_SURVEYS',
    'USER_PANEL_STEP_PARTICIPATION_METHOD_TESTS',
    'USER_PANEL_STEP_PARTICIPATION_METHOD_ONSITE_AT_CUSTOMER',
    'USER_PANEL_STEP_PARTICIPATION_METHOD_ONSITE_AT_ECONOMIC',
    'USER_PANEL_VALID_PHONE_MESSAGE',
    'USER_PANEL_VALID_EMAIL_MESSAGE',
];
